// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMeibography_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM9 7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 1C4.27224 1 0.888085 3.54955 0 7C0 10 2.99992 15 8 15C13.0001 15 16 10 16 7C15.1119 3.54955 11.7276 1 7.99992 1ZM14 7C13.1763 4.66962 10.6124 3 7.99992 3C5.38748 3 2.82367 4.66962 2 7C2.82367 9.33039 5.38748 11 7.99992 11C10.6124 11 13.1763 9.33039 14 7Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.999 10C15.999 12.2091 14.2087 14 12.0002 14C9.79177 14 8.00146 12.2091 8.00146 10C8.00146 7.79086 9.79177 6 12.0002 6C14.2087 6 15.999 7.79086 15.999 10ZM13.9996 10C13.9996 11.1046 13.1045 12 12.0002 12C10.896 12 10.0008 11.1046 10.0008 10C10.0008 8.89543 10.896 8 12.0002 8C13.1045 8 13.9996 8.89543 13.9996 10Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C17.4062 2 22.0415 5.3021 24 10C24 12.21 22.7137 14.9446 20.6611 17.0965C18.5823 19.2759 15.5852 21 12 21C8.41477 21 5.4177 19.2759 3.33889 17.0965C1.2863 14.9446 0 12.21 0 10C1.95852 5.3021 6.59376 2 12 2ZM5.05728 15.9913C5.06023 15.9942 5.06317 15.9971 5.06613 16H5.07101C5.06643 15.9971 5.06185 15.9942 5.05728 15.9913ZM12.0005 16C16.2739 16 19.9779 13.5617 21.7981 10C19.9779 6.43833 16.2734 4 12 4C7.72662 4 4.02306 6.43832 2.20291 10C4.02306 13.5617 7.72711 16 12.0005 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedMeibography is a generated icon component.
 */
let IconMedMeibography = IconMedMeibography_1 = class IconMedMeibography extends IconBaseElement {
    render() {
        return html `${IconMedMeibography_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMeibography.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedMeibography = IconMedMeibography_1 = __decorate([
    customElement('zui-icon-med-meibography')
], IconMedMeibography);
export { IconMedMeibography };
